<template>
  <v-container>
    <h2>Visitors</h2>
    <v-data-table  v-if="list" :headers="headers" :items="list">
      <template v-slot:item.id="{ item }">
      <router-link :to="{name: 'visitor', params: { visitor: item.id }}">{{ item.id }}</router-link>
    </template>
    </v-data-table>
    <v-skeleton-loader v-else
      type="table"
    ></v-skeleton-loader>
    <v-btn color="primary" :disabled="nextToken == null" @click="loadList">Load more</v-btn>
    </v-container>
</template>

<script>

  import { mapState } from "vuex";
  import ParseRoute from "@/mixins/parse-route";

  export default {
    name: 'Visitors',
    mixins: [ParseRoute],
    data() {
      return {
        headers: [
          { text: 'ID', value: 'id' },
          { text: 'Activity', value: 'activity' },
          { text: 'Last action', value: 'lastAction'},
        ]
      };
    },
    computed: {
      ...mapState('visitors', ['list', 'nextToken']),
    },
    methods: {
      loadList() {
          this.$store.dispatch('visitors/list', { domainID: this.domain, sortDirection: 'DESC', nextToken: this.nextToken });
      }
    },
    created() {
      if(!this.list || !this.list.length) {
        this.loadList();
      }
    }
  }
</script>
